import angular from 'angular';
import constants from 'app/constants';
import {
  controlDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './delete-control-confirm-dialog.controller';
import template from './delete-control-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId, control, process, isEditProcessDialog, risk,
    isApproveProcessDialog,
    isPraProcessMain,
  }) {
    return {
      controller,
      controllerAs: 'deleteConfirmDialogVM',
      locals: {
        customerId,
        control,
        process,
        isEditProcessDialog,
        isApproveProcessDialog,
        isPraProcessMain,
        risk,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.control.deleteControlConfirmDialog', [
  alerts,
  controlDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('deleteControlConfirmDialog', dialogService)
  .name;
